import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const getInitialLang = () => {
    return location.pathname.startsWith('/en') ? 'en' : 'fr';
  };
  
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    const newLang = location.pathname.startsWith('/en') ? 'en' : 'fr';
    if (newLang !== lang) {
      setLang(newLang);
    }
  }, [location.pathname, lang]);

  const switchLanguage = (newLang) => {
    const currentPath = location.pathname;
    let newPath;

    if (newLang === 'en') {
      if (currentPath.startsWith('/en')) {
        newPath = currentPath;
      } else if (currentPath === '/') {
        newPath = '/en';
      } else {
        newPath = `/en${currentPath}`;
      }
    } else {
      if (currentPath.startsWith('/en')) {
        newPath = currentPath.replace(/^\/en/, '') || '/';
      } else {
        newPath = currentPath;
      }
    }

    setLang(newLang);
    navigate(newPath);
  };

  const t = (frText, enText) => {
    return lang === 'en' ? enText : frText;
  };

  const getLocalizedPath = (frPath, enPath) => {
    return lang === 'en' ? enPath : frPath;
  };

  return (
    <LanguageContext.Provider value={{ lang, switchLanguage, t, getLocalizedPath }}>
      {children}
    </LanguageContext.Provider>
  );
};
